/* Project Import will be here */
import { IGeoLocationModel } from "models/commonModels";
import { setRetailerCurrentPosition } from "reducers/common";
/* Project Import will be here */

const getCurrentPosition = (props) => {
    return dispatch => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const currentPosition: IGeoLocationModel = {
                        lat: position.coords.latitude,
                        long: position.coords.longitude
                    }

                    /* Store the retailer current position in store */
                    dispatch(setRetailerCurrentPosition(currentPosition));
                }
            );
        }
    };
};

export default getCurrentPosition;